import { get, post } from "./api-client";
import type { AddCartItemViewModel, CartItemViewModel, DeleteCartItemViewModel } from "@/types/models/cart/cart-item-view-model";

export default {
    getShoppingCart: async (customerId: Nullable<number>) => get<CartItemViewModel[]>('/cart/getShoppingCart', { params: { customerId } }),

    addProductToCart: async (model: AddCartItemViewModel) => post('/cart/addProductToCart', model),

    deleteProductFromCart: async (model: DeleteCartItemViewModel) => post('/cart/deleteProductFromCart', model)
};